"use client";

var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { useFlightsSearch } from "@lib/context/flights/search-context";
import { useFlightSelection } from "@lib/hooks/use-flight-selection";
import IatasAutocompleteInput from "@modules/flights/shared/inputs/inputs-bar/components/locations-autocomplete";
import useCssModules from "@lib/hooks/use-css-modules";
import { usePathname } from "next/navigation";
import MuscleButton from "@modules/shared/components/buttons/muscle-button";
export const FlightDestinationSelection = () => {
  const t = useTranslations("Flights");
  const {
    setNode
  } = useForwardNode();
  const {
    togglePanel
  } = useSideOverPanel();
  const {
    currentFlightIndex
  } = useFlightsSearch();
  const pathname = usePathname();
  const {
    currentFlight,
    updateDestination
  } = useFlightSelection(currentFlightIndex);
  const {
    cssModules
  } = useCssModules();
  const {
    destinationSelectionApplyButton,
    destinationSelectionCancelButton,
    destinationSelectionApplyButtonContainer,
    destinationSelectionPanelContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.DestinationSelection) || {};
  const {
    0: showValidation,
    1: setShowValidation
  } = useState(false);
  const {
    0: localDestinationSelection,
    1: setLocalDestinationSelection
  } = useState();

  // Custom validation for destination selection step - only validates destination
  const validateDestinationSelection = flightInfo => {
    if (!flightInfo.destination_iata || !flightInfo.destination) {
      return {
        success: false,
        message: "SEARCH_VALIDATIONS.NO_DESTINATION_SELECTED",
        field: "destination",
        index: currentFlightIndex
      };
    }
    return {
      success: true,
      message: "success",
      field: "",
      index: currentFlightIndex
    };
  };
  const {
    0: validation,
    1: setValidation
  } = useState(() => validateDestinationSelection(currentFlight));

  // Initialize local destination selection from current flight data
  useEffect(() => {
    if (currentFlight.destination_iata) {
      const existingDestination = {
        id: currentFlight.destination_iata,
        title: currentFlight.destination || "",
        value: currentFlight.flight_type_destination || ""
      };
      setLocalDestinationSelection(existingDestination);
    } else {
      setLocalDestinationSelection(undefined);
    }
  }, [currentFlight.destination_iata, currentFlight.destination, currentFlight.flight_type_destination]);

  // Update validation when inputs change
  useEffect(() => {
    const validation = validateDestinationSelection(currentFlight);
    setValidation(validation);
  }, [currentFlight]);

  // Update flight data when local selection changes
  useEffect(() => {
    if (localDestinationSelection && localDestinationSelection.id !== currentFlight.destination_iata) {
      updateDestination(localDestinationSelection);
    }
  }, [localDestinationSelection, currentFlight.destination_iata, updateDestination]);
  const handleDestinationSelection = autocompleteOption => {
    setLocalDestinationSelection(autocompleteOption);
  };
  return __jsx("div", {
    className: destinationSelectionPanelContainer
  }, __jsx(IatasAutocompleteInput, {
    identifier: "destination-mobile",
    label: t("WRITE_YOUR_DESTINATION_FLIGHT"),
    flightInfoLocationData: localDestinationSelection === null || localDestinationSelection === void 0 ? void 0 : localDestinationSelection.value,
    updateFlightInfo: handleDestinationSelection,
    hasErrors: showValidation && validation.field === "destination" && validation.index === currentFlightIndex,
    excludeIataCode: currentFlight === null || currentFlight === void 0 ? void 0 : currentFlight.origin_iata,
    disablePopper: false
    // Mobile-specific styling props
    ,
    customInputClass: "tx-plg-regular",
    className: "mobile-autocomplete-no-border",
    disableLabelAnimation: true,
    useBorderlessStyle: true
  }), showValidation && validation.field === "destination" && validation.index === currentFlightIndex && __jsx("p", {
    className: "mt-2 text-xs text-red-600 font-medium"
  }, t(validation.message)), __jsx("div", {
    className: destinationSelectionApplyButtonContainer
  }, __jsx(MuscleButton, {
    disabled: !validation.success,
    variant: "solidXL",
    onClick: () => setNode("CalendarSelection")
  }, t("CONTINUE")), pathname.includes("/flights/select") ? __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: () => setNode("EditFlightSelection")
  }, t("MAKE_CHANGES")) : __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: () => togglePanel()
  }, t("CANCEL"))));
};